<template>
<div>
   <div class="code-box">
      <h5>分享到微信</h5>
      <div id="div_div">
          <div class="qrcode" ref="qrCodeUrl"></div>
       </div>
      <p>用微信“扫一扫”，点击右上角分享按钮，<br>即可将网页分享给您的微信好友或朋友圈。</p>
    </div>
</div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  export default {
    name: 'Code',
    components: {

    },
    data() {
      return {

      };
    },
    mounted(){
       console.log("加载二维码 ");
       this.creatQrCode();
    },
    methods: {
      creatQrCode() {
              console.log(this.$route.query.url);
              var url = this.$route.query.url;
              var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                  text: url, // 需要转换为动态文章页面二维码的地址
                  width: 200,
                  height: 200,
                  colorDark: '#000000',
                  colorLight: '#ffffff',
                  correctLevel: QRCode.CorrectLevel.H
              })
          },
    }
  };
</script>

<style>
   .code-box{
        width: 262px; margin: 50px auto; border: 1px solid #ddd; padding: 10px
      }
      .code-box h5{margin: 0;}
      .code-box p{text-align:center;font-size: 12px; line-height: 22px; margin: 0; color: #555;}
      #div_div{width: 200px; height: 200px; margin: 20px auto}
</style>



// WEBPACK FOOTER //
// src/views/Front/Code.vue